import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e570da6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-summary-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, null, -1))
const _hoisted_3 = { class: "dropdown-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dropdown-container",
      style: _normalizeStyle(_ctx.profileImageUrl)
    }, [
      _createElementVNode("details", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToMyBlog && _ctx.goToMyBlog(...args)))
          }, "내 블로그"),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToBookmarks && _ctx.goToBookmarks(...args)))
          }, "내 북마크"),
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToSetting && _ctx.goToSetting(...args)))
          }, "내 정보 수정"),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToAdmin && _ctx.goToAdmin(...args)))
              }, "관리자"))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
          }, "로그아웃")
        ])
      ])
    ], 4)
  ]))
}